<ng-container *ngrxLet="lagDevices$ as lagDevices">
  <div *ngIf="sequenceCombined$ | async as sequence">
    <h2 id="sequencing-title">
      {{ '+INSTALLATIONS.INSTALLATION.CASCADES.SEQUENCE_STRATEGY.TITLE' | translate }}
    </h2>
    <div class="flex flex-row flex-wrap gap-[20px] grid">
      <app-sequencing-strategy-tile
        title="{{ '+INSTALLATIONS.INSTALLATION.CASCADES_SEQUENCE.TITLE' | translate }}"
        data-at-cascades-sequence
        [isCascadeList]="true"
        [lagDevices]="lagDevices"
      >
      </app-sequencing-strategy-tile>
      <app-sequencing-strategy-tile
        [isOn]="sequence.strategy | featureValue: 'fixedMode'"
        [isToggleEnabled]="canExecuteCommands"
        title="{{
          '+INSTALLATIONS.INSTALLATION.CASCADES.SEQUENCE_STRATEGY.FIXED.TITLE' | translate
        }}"
        description="{{
          '+INSTALLATIONS.INSTALLATION.CASCADES.SEQUENCE_STRATEGY.FIXED.DESCRIPTION' | translate
        }}"
        (switchChange)="onSwitchChanged(SequenceModes.Fixed, $event)"
      >
      </app-sequencing-strategy-tile>
      <app-sequencing-strategy-tile
        [isOn]="sequence.strategy | featureValue: 'fixedFirst'"
        [isToggleEnabled]="canExecuteCommands"
        title="{{
          '+INSTALLATIONS.INSTALLATION.CASCADES.SEQUENCE_STRATEGY.FIXED_FIRST.TITLE' | translate
        }}"
        description="{{
          '+INSTALLATIONS.INSTALLATION.CASCADES.SEQUENCE_STRATEGY.FIXED_FIRST.DESCRIPTION'
            | translate
        }}"
        (switchChange)="onSwitchChanged(SequenceModes.FixedFirst, $event)"
      >
        <div class="field-container">
          <mat-form-field mat-select-height-medium>
            <mat-select
              *ngIf="lagDevices"
              [compareWith]="compareLagDevices"
              [(ngModel)]="fixedFirstLagDevice"
              [disabled]="!canExecuteCommands"
              (selectionChange)="onFixedFirstLagDeviceChanged()"
              fieldTextContentTooltip
            >
              <mat-option
                *ngFor="let lagDevice of lagDevices"
                [value]="lagDevice"
                gtm="onSelect"
                gtmAction="Select fixed first device"
                gtmCategory="cascadesSequenceStrategy"
                fieldTextContentTooltip
              >
                {{ lagDevice.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </app-sequencing-strategy-tile>
      <app-sequencing-strategy-tile
        [isOn]="sequence.strategy | featureValue: 'fixedLast'"
        [isToggleEnabled]="canExecuteCommands"
        title="{{
          '+INSTALLATIONS.INSTALLATION.CASCADES.SEQUENCE_STRATEGY.FIXED_LAST.TITLE' | translate
        }}"
        description="{{
          '+INSTALLATIONS.INSTALLATION.CASCADES.SEQUENCE_STRATEGY.FIXED_LAST.DESCRIPTION'
            | translate
        }}"
        (switchChange)="onSwitchChanged(SequenceModes.FixedLast, $event)"
      >
        <div class="field-container">
          <mat-form-field mat-select-height-medium>
            <mat-select
              *ngIf="lagDevices"
              [compareWith]="compareLagDevices"
              [(ngModel)]="fixedLastLagDevice"
              [disabled]="!canExecuteCommands"
              (selectionChange)="onFixedLastLagDeviceChanged()"
              fieldTextContentTooltip
            >
              <mat-option
                *ngFor="let lagDevice of lagDevices"
                [value]="lagDevice"
                gtm="onSelect"
                gtmAction="Select fixed last device"
                gtmCategory="cascadesSequenceStrategy"
                fieldTextContentTooltip
              >
                {{ lagDevice.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </app-sequencing-strategy-tile>
      <app-sequencing-strategy-tile
        [isOn]="sequence.strategy | featureValue: 'burnerRuntime'"
        [isToggleEnabled]="canExecuteCommands && !formGroup.invalid"
        title="{{
          '+INSTALLATIONS.INSTALLATION.CASCADES.SEQUENCE_STRATEGY.BURNER_RUNTIME.TITLE' | translate
        }}"
        description="{{
          '+INSTALLATIONS.INSTALLATION.CASCADES.SEQUENCE_STRATEGY.BURNER_RUNTIME.DESCRIPTION'
            | translate
        }}"
        (switchChange)="onSwitchChanged(SequenceModes.BurnerRuntime, $event)"
      >
        <div class="field-container">
          <form [formGroup]="formGroup" class="flex flex-row gap-[20px]">
            <mat-form-field mat-input-height-large>
              <input
                [formControl]="formGroup.controls.burnerRuntimeValue"
                type="text"
                matInput
                gtm="onTextField"
                gtmAction="Set Burner Runtime value"
                gtmCategory="cascadesSequenceStrategy"
                fieldTextContentTooltip
              />
              <mat-error *ngIf="formGroup.invalid">
                {{
                  '+INSTALLATIONS.INSTALLATION.CASCADES.SEQUENCE_STRATEGY.BURNER_RUNTIME.VALIDATION_ERROR'
                    | translate
                }}
              </mat-error>
            </mat-form-field>
            <button
              mat-stroked-button
              gtm="onSet"
              gtmAction="Save new Burner Runtime value"
              gtmCategory="cascadesSequenceStrategy"
              [disabled]="isBurnerRuntimeSaveButtonDisabled"
              (click)="onBurnerRuntimeSaveClicked()"
            >
              {{ 'GENERAL.BUTTON.SAVE' | translate }}
            </button>
          </form>
        </div>
      </app-sequencing-strategy-tile>
    </div>
  </div>
</ng-container>
